export const getThreadInputCode = (articleCode: string, threadId: string) => `${articleCode}/${threadId}`
